import React, { useState, useEffect } from 'react';
import { FiCalendar, FiMapPin } from 'react-icons/fi';
import { eventAPI } from '../../api/services';
import { formatCurrency } from '../../utils/formatters';
import { useTranslation } from 'react-i18next';

const IMAGES = [
  'https://images.unsplash.com/photo-1461896836934-bd45ba7b5462?w=400&q=80',
  'https://images.unsplash.com/photo-1587280501635-68a0e82cd5ff?w=400&q=80',
  'https://images.unsplash.com/photo-1530549387789-4c1017266635?w=400&q=80',
  'https://images.unsplash.com/photo-1554068865-24cecd4e34b8?w=400&q=80',
  'https://images.unsplash.com/photo-1574629810360-7efbbe195018?w=400&q=80',
  'https://images.unsplash.com/photo-1546519638-68e109498ffc?w=400&q=80',
];

const EventsPage = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const { t } = useTranslation();

  useEffect(() => {
    eventAPI.getAll()
      .then(r => setEvents(r.data?.data || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <>
      <div className="page-header">
        <div className="container">
          <img src="/illustrations/events.png" alt="Events" className="page-header-illustration" />
          <span className="section-label">{t('events.label')}</span>
          <h1>{t('events.title')}</h1>
          <p>{t('events.subtitle')}</p>
        </div>
      </div>

      <section className="section" style={{ paddingTop: 32 }}>
        <div className="container">
          {loading ? (
            <div className="loading"><div className="spinner"></div></div>
          ) : events.length === 0 ? (
            <div className="empty-state">
              <div className="icon">📅</div>
              <h3>{t('events.no_events')}</h3>
              <p>{t('events.check_back')}</p>
            </div>
          ) : (
            <div className="grid-3">
              {events.map((event, i) => (
                <div key={event.id} className="card event-card" style={{ position: 'relative' }}>
                  <div style={{ position: 'relative' }}>
                    <img src={event.mediaUrl || IMAGES[i % IMAGES.length]} alt={event.title} className="card-img" />
                    {event.date && (
                      <span className="event-date">
                        <FiCalendar style={{ marginRight: 4 }} />
                        {event.date.replace('T', ' ').substring(0, 16)}
                      </span>
                    )}
                  </div>
                  <div className="card-body">
                    <h3 style={{ fontSize: '1.05rem', fontWeight: 700, marginBottom: 6 }}>{event.title}</h3>
                    <div className="tooltip-container">
                      <p className="line-clamp-2" style={{ color: 'var(--text-secondary)', fontSize: '0.85rem', marginBottom: 10, lineHeight: 1.6 }}>
                        {event.description}
                      </p>
                      {event.description?.length > 60 && (
                        <span className="tooltip-text">{event.description}</span>
                      )}
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <span style={{ color: 'var(--text-muted)', fontSize: '0.8rem', display: 'flex', alignItems: 'center', gap: 4 }}><FiMapPin />{event.location}</span>
                      {event.price != null && <span className="event-price">{event.price === 0 ? t('events.free') : formatCurrency(event.price)}</span>}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default EventsPage;
